import React, { Component } from 'react'
import '../style/components/rating-bar.css'

export default class RatingBar extends Component {
  render() {
    const { rating } = this.props

    let scale;

    if (this.props.scale) {
      scale = (
        <div className='rating-bar-scale'>
          <span>0</span>
          <span>25</span>
        </div>
      )
    }

    return (
      <div>
        <div className='rating-bar-outer'>
          <svg
            className='rating-bar-inner'
            viewBox='0 0 200 10'
            preserveAspectRatio='none'
            style={{ width: `${rating.value / 25 * 100}%` }}
          >
            <line x1={0} y1={5} x2={200} y2={5} style={{ stroke: rating.color }} />
          </svg>
        </div>
        {scale}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RatingBar.js